
        import { CookieConsentController } from '/src/services/cookieConsentController.ts';
        import '/src/utils/emojiManager.ts';
        
        document.addEventListener('DOMContentLoaded', () => {
            new CookieConsentController();
        });
    